/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Overlap_TextInputs */



/**
* | output |
* | --- |
* | "The subtitle file you are importing has overlapping events. Would you like to fix them?" |
*
* @param {Subtitle_Import_Overlap_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_overlap_text = /** @type {((inputs?: Subtitle_Import_Overlap_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Overlap_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le fichier de sous-titres que vous importez contient des evenements qui se chevauchent. Voulez-vous les corriger ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die importierte Untertiteldatei enthält überlappende Ereignisse. Möchten Sie diese beheben?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il file dei sottotitoli che stai importando presenta eventi sovrapposti. Vuoi correggerli?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В импортируемом файле субтитров присутствуют наложения событий. Хотите ли вы их исправить?")
	if (locale === "es") return /** @type {LocalizedString} */ ("El archivo de subtítulos que estás importando tiene eventos superpuestos. ¿Quieres corregirlos?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您导入的字幕文件存在重叠事件。是否要修复这些问题？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート中の字幕ファイルには重複したイベントがあります。修正しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आप जिस सबटाइटल फ़ाइल को इंपोर्ट कर रहे हैं, उसमें कुछ इवेंट ओवरलैप हो रहे हैं। क्या आप उन्हें ठीक करना चाहेंगे?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O arquivo de legendas que você está importando contém eventos sobrepostos. Deseja corrigi-los?")
	return /** @type {LocalizedString} */ ("The subtitle file you are importing has overlapping events. Would you like to fix them?")
});